export function ikkeEndre(verdi) {
	return verdi;
}

export function erUsann(verdi) {
	return !verdi;
}

export function erSann(verdi) {
	return !erUsann(verdi);
}

export function garanterListe(liste) {
	return Array.isArray(liste) ? liste : [];
}

export function garanterObjekt(objekt) {
	return typeof objekt !== 'object' || Array.isArray(objekt) ? {} : objekt;
}
